import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { userActions, shopActions } from "../../_actions";

import TopBar from "../Common/TopBar/TopBar";
import SideBar from "../Common/SideBar/SideBar";
import Footer from "../Common/Footer/Footer";
import { apiConstants } from "../../_constants/api.constants";
import config from '../../config';

const timeHolder = [
"12:00 AM",
"1:00 AM",
"2:00 AM",
"3:00 AM",
"4:00 AM",
"5:00 AM",
"6:00 AM",
"7:00 AM",
"8:00 AM",
"9:00 AM",
"10:00 AM",
"11:00 AM",
"12:00 PM",
"1:00 PM",
"2:00 PM",
"3:00 PM",
"4:00 PM",
"5:00 PM",
"6:00 PM",
"7:00 PM",
"8:00 PM",
"9:00 PM",
"10:00 PM",
"11:00 PM",
];



class UsersProfile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      submitted: false,
      user: {},
      shoptime : { initilize : 0},
      codDeliveryCharge : 0,
      file: "",
      imagePreviewUrl: "",
      profileUpdate: false,
      trigGetShopTime : false,
      profileImgUpdate: false,
      //-- We are using for validation
      errors: {
        firstname: "",
        lastname: "",
        contact: ""
      }
    };
  }

  //-- handle validation for page
  handleValidation() {
    const { siteConstants } = this.props.language;

    let fields = this.state.user;
    // let errors = {};
    let formIsValid = true;

    //Name
    if (
      fields.firstname == "" ||
      fields.lastname == "" ||
      fields.mobile_number == ""
    ) {
      formIsValid = false;
      if (fields.firstname == "") {
        this.setState({
          errors: { firstname: siteConstants.ERR_CAN_NOT_BLANK }
        });
      }
      if (fields.lastname == "") {
        this.setState({
          errors: { lastname: siteConstants.ERR_CAN_NOT_BLANK }
        });
      }

      if (fields.mobile_number == "") {
        this.setState({ errors: { contact: siteConstants.ERR_CAN_NOT_BLANK } });
      }
    }

    if (fields.firstname !== "" && fields.firstname !== undefined) {
      if (fields.firstname.match(/^[a-zA-Z]+$/) === null) {
        formIsValid = false;
        this.setState({
          errors: { firstname: siteConstants.ERR_ONLY_LETTERS }
        });
      }
    }

    if (fields.lastname !== "" && fields.lastname !== undefined) {
      if (fields.lastname.match(/^[a-zA-Z]+$/) === null) {
        formIsValid = false;
        this.setState({ errors: { lastname: siteConstants.ERR_ONLY_LETTERS } });
      }
    }

    if (fields.mobile_number !== "" && fields.mobile_number !== undefined) {
      if (String(fields.mobile_number).match(/^[0-9]*$/) === null) {
        formIsValid = false;
        this.setState({ errors: { contact: siteConstants.ERR_ONLY_NUMBERS } });
      }
    }

    return formIsValid;
  }

  //-- update the user profile information
  updateAdminProfileInfo = e => {
    e.preventDefault();
    this.setState({ profileUpdate: true });

    var user = this.state.user;
    user.shoptime = this.state.shoptime;
    user.codDeliveryCharge = this.state.codDeliveryCharge;

    if (this.handleValidation()) {
      this.props.dispatch(
        userActions.updateAdminProfileData(
          apiConstants.ADMIN_PROFILE,
          user
        )
      );

      sessionStorage.setItem("user", JSON.stringify(user));
    } else {
      //alert("Form has errors.");
    }
  };

  //-- we are setting the Values
  handleChange(event) {
    const { name, value } = event.target;
    const { user } = this.state;
    this.setState({
      user: {
        ...user,
        [name]: value
      }
    });
  }

  //-- Will need to fetch user data
  componentDidMount() {
    const { dispatch } = this.props;
    let obj = {};
    obj.id = JSON.parse(sessionStorage.getItem("user"))._id;
    dispatch(userActions.getAdminDetails(apiConstants.ADMIN_PROFILE, obj));

    const shopkeeprObj = {};
    shopkeeprObj.shopkeeprId = obj.id;
    dispatch(shopActions.getShopKeeper(apiConstants.GET_SHOPKEEPER, shopkeeprObj));
  }

  /*
   * componentWillReceiveProps - Whenever Props change, it will call and store data
   * update the state values with new props values, this method will get called whenever any change happens to props values
   */
  componentWillReceiveProps(props) {
    if (props.userDetails) {
      if (props.userDetails.userDetails) {
        if (props.userDetails.userDetails.data) {
          //-- profileUpdate - because only update list when we don't want to change the userlist
          if (this.state.profileUpdate === false) {
            this.setState({
              user: props.userDetails.userDetails.data
            });
          }
        }
      }
    }
    if (props.uploadimage.success) {
      if (
        props.uploadimage.data !== undefined &&
        props.uploadimage.data !== ""
      ) {
        this.setState(prevState => ({
          user: {
            ...prevState.user,
            profile_image: props.uploadimage.data
          }
        }));
      }
    }

    // get shop timing if shopkeeper
    if (props.getShopkeeper !== undefined) {
        if (props.getShopkeeper.data.shopkeeper) {
            const shopeeprUser = props.getShopkeeper.data.shopkeeper[0];
            // if( Object.keys( this.state.shoptime ).length === 0 ){
              if(
                this.state.shoptime !== undefined &&
                this.state.shoptime.initilize !== undefined &&
                this.state.shoptime.initilize === 0 &&
                shopeeprUser !== undefined &&
                shopeeprUser.shopData !== undefined ){
                this.setState({
                  shoptime: shopeeprUser.shopData[0].shoptime,
                  codDeliveryCharge : shopeeprUser.shopData[0].codDeliveryCharge !== undefined && shopeeprUser.shopData[0].codDeliveryCharge ? shopeeprUser.shopData[0].codDeliveryCharge : 0,
                });
              }
        }
    }
  }



  handleProfileChange() {
    document.querySelector("input[type='file']").click();
  }
  handleImageChange(e) {

    let reader = new FileReader();
    let file = e.target.files[0];

    reader.onloadend = () => {
      this.setState({
        file: file,
      });
    };

    reader.readAsDataURL(file);

    if (file) {
      let postData = {};
      postData.files = file;

      this.props.dispatch(
        userActions.uploadProfileImg(apiConstants.UPLOAD_IMAGE, postData)
      );

      this.setState({ profileUpdate: true });
    }
  }



  shopTimeHandle = (event) => {

    const { name, value } = event.target;
    const { shoptime } = this.state;
    this.setState({
      shoptime: {
        ...shoptime,
        [name]: value
      }
    });

  }

  handleChangeCodCharge = (event) => {
    const { name, value } = event.target;
    this.setState({
      codDeliveryCharge:  value
    });

  }

  render() {
    const { user, shoptime } = this.state;
    let userRole = '';
    if(user.role_type !== undefined ){
      let userRoleArray = Object.values(user.role_type);
      userRole = userRoleArray[0];
    }
    const { siteConstants } = this.props.language;

    let { imagePreviewUrl } = this.state;
    let $imagePreview = null;
    if (imagePreviewUrl) {
      $imagePreview = <img src={imagePreviewUrl} />;
    } else {
      $imagePreview = (
        <div className="previewText">Please select an Image for Preview</div>
      );
    }

    let value = "./assets/img/svg/user.svg";
    if (
      this.state.user.profile_image !== undefined &&
      this.state.user.profile_image !== "" &&
      this.state.user.profile_image !== null
    ) {
      value = config.imgPath + "/" + this.state.user.profile_image;
    }


    return (
      <div id="wrapper">
        <SideBar />

        <div id="content-wrapper" className="d-flex flex-column">
          {/* <!-- Main Content --> */}
          <div id="content">
            <TopBar />
            <nav className="" aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="/dashboard">{siteConstants.GEN_DASHBOARD}</a>
                </li>
                <li className="active breadcrumb-item" aria-current="page">
                  {siteConstants.LABEL_PROFILE}
                </li>

              </ol>
            </nav>

            <div className="container-fluid">

              <div className="card shadow mb-4">
                <div className="card-body">
                  <div className="table-responsive">
                    <div className="row">
                      <div className="col-sm-3"></div>
                      <div className="col-sm-6">
                        <form role="form">
                          <div className="p-5">
                            <div className="text-center">
                              <div className="container profilePic">
                                <img
                                  className="img-profile rounded-circle"
                                  style={{ width: "150px" }}
                                  src={value}
                                />
                                <div className="overlay">
                                  <a
                                    href="javascript:void(0)"
                                    class="icon"
                                    title="User Profile"
                                    onClick={this.handleProfileChange}
                                  >
                                    <i class="fas fa-edit"></i>
                                  </a>
                                </div>
                              </div>

                              <h1 className="h4 text-gray-900 mb-4">
                                {user.firstname + " " + user.lastname}
                              </h1>
                            </div>
                            <div className="form-group">
                              <label>{siteConstants.LABEL_F_NAME}</label>
                              <label className="my-error ml-3">
                                {this.state.errors.firstname}
                              </label>
                              <input
                                type="text"
                                className="form-control form-control-user"
                                name="firstname"
                                value={user.firstname}
                                onChange={e => this.handleChange(e)}
                              />
                            </div>

                            <div className="form-group">
                              <label>{siteConstants.LABEL_L_NAME}</label>
                              <label className="my-error ml-3">
                                {this.state.errors.lastname}
                              </label>
                              <input
                                type="text"
                                className="form-control form-control-user"
                                name="lastname"
                                value={user.lastname}
                                onChange={e => this.handleChange(e)}
                              />
                            </div>

                            <div className="form-group">
                              <label>{siteConstants.LABEL_CONTACT_NO}</label>
                              <label className="my-error ml-3">
                                {this.state.errors.contact}
                              </label>
                              <input
                                type="text"
                                className="form-control form-control-user"
                                name="mobile_number"
                                value={user.mobile_number}
                                onChange={e => this.handleChange(e)}
                              />
                            </div>



                      {
                        userRole === "shopkeeper" ?
                        <Fragment>
                            <div className="form-group">
                              <label>{siteConstants.LABEL_SHOP_TIMING}</label>
                            </div>




                            <div className="form-group">
                                <div className="row">
                                  <div className="col-md-4 col-sm-4 col-xs-4">
                                    <label>{siteConstants.LABEL_MONDAY}</label>
                                  </div>
                                  <div className="col-md-4 col-sm-4 col-xs-4">
                                    <select name="mon_open" onChange={ (e) => this.shopTimeHandle(e)} value={shoptime.mon_open !== undefined ? shoptime.mon_open : '' }>
                                      <option value="off">Off</option>
                                            {
                                              timeHolder.map( (time) => {
                                              return <option value={time}>{time}</option>
                                              })
                                            }
                                    </select>
                                  </div>
                                  <div className="col-md-4 col-sm-4 col-xs-4">
                                    <select name="mon_close" onChange={ (e) => this.shopTimeHandle(e)} value={shoptime.mon_close}>
                                      <option value="off">Off</option>
                                            {
                                              timeHolder.map( (time) => {
                                              return <option value={time}>{time}</option>
                                              })
                                            }
                                    </select>
                                  </div>
                                </div>
                            </div>

                            <div className="form-group">
                                <div className="row">
                                  <div className="col-md-4 col-sm-4 col-xs-4">
                                    <label>{siteConstants.LABEL_TUESDAY}</label>
                                  </div>
                                  <div className="col-md-4 col-sm-4 col-xs-4">
                                    <select name="tue_open" onChange={ (e) => this.shopTimeHandle(e)} value={shoptime.tue_open} >
                                    <option value="off">Off</option>
                                            {
                                              timeHolder.map( (time) => {
                                              return <option value={time}>{time}</option>
                                              })
                                            }
                                    </select>
                                  </div>
                                  <div className="col-md-4 col-sm-4 col-xs-4">
                                    <select name="tue_close" onChange={ (e) => this.shopTimeHandle(e)} value={shoptime.tue_close} >
                                    <option value="off">Off</option>
                                            {
                                              timeHolder.map( (time) => {
                                              return <option value={time}>{time}</option>
                                              })
                                            }
                                    </select>
                                  </div>
                                </div>
                            </div>

                            <div className="form-group">
                                <div className="row">
                                  <div className="col-md-4 col-sm-4 col-xs-4">
                                    <label>{siteConstants.LABEL_WEDNESDAY}</label>
                                  </div>
                                  <div className="col-md-4 col-sm-4 col-xs-4">
                                    <select name="wed_open" onChange={ (e) => this.shopTimeHandle(e)} value={shoptime.wed_open}>
                                    <option value="off">Off</option>
                                            {
                                              timeHolder.map( (time) => {
                                              return <option value={time}>{time}</option>
                                              })
                                            }
                                    </select>
                                  </div>
                                  <div className="col-md-4 col-sm-4 col-xs-4">
                                    <select name="wed_close" onChange={ (e) => this.shopTimeHandle(e)} value={shoptime.wed_close} >
                                    <option value="off">Off</option>
                                            {
                                              timeHolder.map( (time) => {
                                              return <option value={time}>{time}</option>
                                              })
                                            }
                                    </select>
                                  </div>
                                </div>
                            </div>

                            <div className="form-group">
                                <div className="row">
                                  <div className="col-md-4 col-sm-4 col-xs-4">
                                    <label>{siteConstants.LABEL_THURSDAY}</label>
                                  </div>
                                  <div className="col-md-4 col-sm-4 col-xs-4">
                                    <select name="thu_open" onChange={ (e) => this.shopTimeHandle(e)} value={shoptime.thu_open} >
                                    <option value="off">Off</option>
                                            {
                                              timeHolder.map( (time) => {
                                              return <option value={time}>{time}</option>
                                              })
                                            }
                                    </select>
                                  </div>
                                  <div className="col-md-4 col-sm-4 col-xs-4">
                                    <select name="thu_close" onChange={ (e) => this.shopTimeHandle(e)} value={shoptime.thu_close} >
                                    <option value="off">Off</option>
                                            {
                                              timeHolder.map( (time) => {
                                              return <option value={time}>{time}</option>
                                              })
                                            }
                                    </select>
                                  </div>
                                </div>
                            </div>

                            <div className="form-group">
                                <div className="row">
                                  <div className="col-md-4 col-sm-4 col-xs-4">
                                    <label>{siteConstants.LABEL_FRIDAY}</label>
                                  </div>
                                  <div className="col-md-4 col-sm-4 col-xs-4">
                                    <select name="fri_open" onChange={ (e) => this.shopTimeHandle(e)} value={shoptime.fri_open} >
                                    <option value="off">Off</option>
                                            {
                                              timeHolder.map( (time) => {
                                              return <option value={time}>{time}</option>
                                              })
                                            }
                                    </select>
                                  </div>
                                  <div className="col-md-4 col-sm-4 col-xs-4">
                                    <select name="fri_close" onChange={ (e) => this.shopTimeHandle(e)} value={shoptime.fri_close} >
                                    <option value="off">Off</option>
                                            {
                                              timeHolder.map( (time) => {
                                              return <option value={time}>{time}</option>
                                              })
                                            }
                                    </select>
                                  </div>
                                </div>
                            </div>

                            <div className="form-group">
                                <div className="row">
                                  <div className="col-md-4 col-sm-4 col-xs-4">
                                    <label>{siteConstants.LABEL_SATURDAY}</label>
                                  </div>
                                  <div className="col-md-4 col-sm-4 col-xs-4">
                                    <select name="sat_open" onChange={ (e) => this.shopTimeHandle(e)} value={shoptime.sat_open} >
                                    <option value="off">Off</option>
                                            {
                                              timeHolder.map( (time) => {
                                              return <option value={time}>{time}</option>
                                              })
                                            }
                                    </select>
                                  </div>
                                  <div className="col-md-4 col-sm-4 col-xs-4">
                                    <select name="sat_close" onChange={ (e) => this.shopTimeHandle(e)} value={shoptime.sat_close} >
                                    <option value="off">Off</option>
                                            {
                                              timeHolder.map( (time) => {
                                              return <option value={time}>{time}</option>
                                              })
                                            }
                                    </select>
                                  </div>
                                </div>
                            </div>

                            <div className="form-group">
                                <div className="row">
                                  <div className="col-md-4 col-sm-4 col-xs-4">
                                    <label>{siteConstants.LABEL_SUNDAY}</label>
                                  </div>
                                  <div className="col-md-4 col-sm-4 col-xs-4">
                                    <select name="sun_open" onChange={ (e) => this.shopTimeHandle(e)} value={shoptime.sun_open} >
                                    <option value="off">Off</option>
                                            {
                                              timeHolder.map( (time) => {
                                              return <option value={time}>{time}</option>
                                              })
                                            }
                                    </select>
                                  </div>
                                  <div className="col-md-4 col-sm-4 col-xs-4">
                                    <select name="sun_close" onChange={ (e) => this.shopTimeHandle(e)} value={shoptime.sun_close} >
                                    <option value="off">Off</option>
                                            {
                                              timeHolder.map( (time) => {
                                              return <option value={time}>{time}</option>
                                              })
                                            }
                                    </select>
                                  </div>
                                </div>
                            </div>


                            <div className="form-group">
                                <div className="row">
                                  <div className="col-md-12 col-sm-12 col-xs-12">
                                    <label>{siteConstants.LABEL_COD_CHARGE}</label>
                                  </div>
                                  <div className="col-md-12 col-sm-12 col-xs-12">
                                  <input
                                    type="text"
                                    className="form-control form-control-user"
                                    name="codDeliveryCharge"
                                    value={this.state.codDeliveryCharge}
                                    onChange={e => this.handleChangeCodCharge(e)}
                                  />
                                  </div>
                                </div>
                            </div>


                        </Fragment> : ""
                      }







                            <div className="form-group">
                              {/* <div className="col-sm-6 mb-3 mb-sm-0"> */}
                              <div>
                                <input
                                  className="fileInput form-control form-control-user"
                                  type="file"
                                  name="userImage"
                                  onChange={e => this.handleImageChange(e)}
                                  style={{ display: "none" }}
                                />

                                {/* <button
                              className="btn btn-primary btn-user mt-3"
                              type="submit"
                              id="submitbtn"
                              style={{display:"none"}}
                              onClick={e => this.handleImageSubmit(e)}
                            >
                            </button>  */}
                              </div>
                              {/* </div> */}

                              {/* <div className="col-sm-6"> */}
                              {/* <div className="imgPreview">{$imagePreview}</div> */}
                            </div>
                            {/* </div> */}

                            <div className="form-group">
                              <button
                                type="submit"
                                className="btn btn-primary btn-user btn-block"
                                onClick={this.updateAdminProfileInfo}
                              >
                                {siteConstants.BTN_SAVE}
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                      <div className="col-sm-3"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- End of Main Content --> */}

          <Footer />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { userDetails, language, uploadimage, getShopkeeper } = state;
  return {
    userDetails,
    language,
    uploadimage,
    getShopkeeper
  };
}

const connectedUsersProfile = connect(mapStateToProps)(UsersProfile);
export { connectedUsersProfile as UsersProfile };
